import { ThemeEvents, CartAddEvent, CartErrorEvent, VariantUpdateEvent, } from "@theme/events";
import { fetchConfig, debounce, onAnimationEnd, prefersReducedMotion, resetShimmer } from '@theme/utilities';
class removeBundleItems extends HTMLElement {
  constructor() {
    super();
    this.boundHandler = null;
  }
  connectedCallback() {
    this.removeBundleItem();
  }
  removeBundleItem() {
    if (this.boundHandler) return;
    this.boundHandler = async (e) => {

      e.preventDefault();
      const spinner = this.querySelector('.spinner');
      spinner?.classList.remove('hidden');

      const staticIds = this.dataset.itemId?.split(',').map(id => id.trim()).filter(Boolean) || [];
      const bundleKey = this.dataset.bundleId;

      let bundleIds = [...staticIds];

      // Re-query cart to make sure we only remove items matching this bundle id
      if (bundleKey) {
        try {
          const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
          const cart = await res.json();
          // Find which property this bundle id belongs to, then only match on that property
          const propertyToMatch = (() => {
            for (const ci of cart.items) {
              if (ci.properties?._rc_bundle === bundleKey) return '_rc_bundle';
              if (ci.properties?._otp_bundle === bundleKey) return '_otp_bundle';
              if (ci.properties?._rc_bundle_parent === bundleKey) return '_rc_bundle_parent';
              if (ci.properties?._otp_bundle_parent === bundleKey) return '_otp_bundle_parent';
            }
            return null;
          })();

          if (propertyToMatch) {
            const matches = cart.items.filter((ci) => ci.properties?.[propertyToMatch] === bundleKey);
            if (matches.length) {
              bundleIds = matches.map((m) => m.key);
            }
          }
        } catch (err) {
          console.warn("Failed to fetch cart before bundle removal", err);
        }
      }

      const updates = Object.fromEntries(
        bundleIds.map((id) => [id, 0])
      );

      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ updates }),
      })
        .then((res) => res.json())
        .then(() => console.log("bundle item remove"))
        .catch((err) => {
          console.error("Error adding to cart:", err);
        })
        .finally(() => {
          console.log("Bundle Item remove sucessfull");
          spinner?.classList.add('hidden');
          const productForm = document.querySelector("product-form-component");
          if (!productForm) return;
          this.dispatchEvent(
            new CartAddEvent({}, productForm.id, {
              didError: false,
              source: "product-form-component",
              itemCount: Number(productForm.dataset.quantityDefault),
              productId: productForm.dataset.productId,
            })
          );
        });
    };

    this.addEventListener("click", this.boundHandler);
  }
}
customElements.define("remove-bundle-item", removeBundleItems);
